import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import LayoutConnector, { ConnectorProps as LayoutProps } from '../connectors/Layout'

const AdminOptions: FC<{ [key: string]: boolean }> = ({ edit, admin }) => {
  const ManageArtwork = dynamic(import('../components/ManageArtwork'), noSSR)
  const AdminPanel = dynamic(import('../components/AdminPanel'), noSSR)
  return (
    <>
      {edit && (
        <>
          <ManageArtwork />
        </>
      )}
      {admin && <AdminPanel />}
    </>
  )
}

const Admin: FC<LayoutProps> = (props) => {
  const { canEditArtwork, isAdmin } = props

  if (!canEditArtwork) {
    return null
  }

  return <AdminOptions edit={canEditArtwork} admin={isAdmin} />
}

export default LayoutConnector(Admin)
